import "@/assets/fonts.css"
import { vuetify } from "@/vuetify.js"
import * as Sentry from "@sentry/vue"
import axios from "axios"
import { createApp } from "vue"
import { useRequestInterceptor, useResponseInterceptor } from "@/interceptor.js"
import App from "@/App.vue"
import router from "@/router"
import { ToastPlugin } from "@/toast"
import { VueQueryPlugin } from "@tanstack/vue-query"
import { queryClient } from "@/query.js"
import { defineEndpoints as defineEndpointsForChargebee } from "@/chargebee.js"
import { auth0 } from "@/auth0.js"

defineEndpointsForChargebee({
  subscription: {
    POST: () => "/partner/subscriptions",
    PUT: id => `/partner/subscriptions/${id}`,
    GET: id => `/partner/subscriptions/${id}`,
  },
  billing: {
    POST: () => "/partner/billing_details",
  },
})

axios.defaults.baseURL = import.meta.env.VITE_API_URL
useRequestInterceptor(axios, auth0)
useResponseInterceptor(axios)

const app = createApp(App)

if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    trackComponents: true,
    tracePropagationTargets: ["localhost", import.meta.env.DOMAIN_NAME, /^\//],
  })
}

app.use(router)
  .use(auth0)
  .use(vuetify)
  .use(ToastPlugin)
  .use(VueQueryPlugin, { queryClient })
  .mount("#app")
